/* eslint-disable */
import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
	Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import {
	getArmazonesAnteojosSol,
	getAccesorios,
	getSolucionesLimpieza,
	getLentesDeContacto,
} from "../../../project/services/ArticuloService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
	tipoArticulo: "AS",
	codigo: "",
	descripcion: "",
	arAsMarca: "",
	arAsModelo: "",
	arAsCategoria: "",
	arAsMaterial: "",
	arAsFormato: "",
	arAsCalibre: "",
	arAsTipo: "",
	slMarca: "",
	slIndicacion: "",
	lcMarca: "",
	lcTiempoUso: "",
	lcEsfera: "",
	lcCilindro: "",
	precioVentaDesde: 0,
	precioVentaHasta: 0,
};

const tipoArticulo = [
	{
		id: "AC",
		descripcion: "Accesorios",
	},
	{
		id: "AS",
		descripcion: "Anteojos de Sol",
	},
	{
		id: "AR",
		descripcion: "Armazones",
	},
	{
		id: "LC",
		descripcion: "Lentes de Contacto",
	},
	{
		id: "SL",
		descripcion: "Soluciones de Limpieza",
	},
];
//
// ################################################################################
//
const BuscarProductoDialog = ({ open, onClose, onSelect }) => {
	const [searchData, setSearchData] = useState(initialSearchData);
	const [articulos, setArticulos] = useState([]);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [tableColumns, setTableColumns] = useState([]);

	const [arAsMarcas, setArAsMarcas] = useState([]);
	const [arAsCategorias, setArAsCategorias] = useState([]);
	const [arAsMateriales, setArAsMateriales] = useState([]);
	const [arAsFormatos, setArAsFormatos] = useState([]);
	const [arAsCalibres, setArAsCalibres] = useState([]);
	const [arAsTipos, setArAsTipos] = useState([]);
	const [lcMarcas, setLcMarcas] = useState([]);
	const [lcTiemposUso, setLcTiemposUso] = useState([]);
	const [slMarcas, setSlMarcas] = useState([]);
	const [slIndicaciones, setSlIndicaciones] = useState([]);

	const codigo = {
		field: "codigo",
		headerName: "Código",
		headerAlign: "center",
		align: "center",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.codigo;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const descripcion = {
		field: "descripcion",
		headerName: "Descripción",
		headerAlign: "center",
		align: "left",
		flex: 3,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.descripcion;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const marcaArAS = {
		field: "descripcion_ar_as_marca",
		headerName: "Marca",
		headerAlign: "center",
		align: "left",
		flex: 3,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.descripcion_ar_as_marca;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const marcaSL = {
		field: "descripcion_sl_marca",
		headerName: "Marca",
		headerAlign: "center",
		align: "left",
		flex: 3,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.descripcion_sl_marca;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const marcaLC = {
		field: "descripcion_lc_marca",
		headerName: "Marca",
		headerAlign: "center",
		align: "left",
		flex: 3,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.descripcion_lc_marca;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const modelo = {
		field: "modelo",
		headerName: "Modelo",
		headerAlign: "center",
		align: "left",
		flex: 3,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.modelo;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const tiempoUso = {
		field: "descripcion_lc_tiempo_uso",
		headerName: "Tiempo Uso",
		headerAlign: "center",
		align: "left",
		flex: 2,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.descripcion_lc_tiempo_uso;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const esfera = {
		field: "esfera",
		headerName: "Esfera",
		headerAlign: "center",
		align: "center",
		flex: 1,
		type: "number",
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.esfera;
			_val = _val ? _val.toFixed(2) : "";
			return _val;
		},
	};

	const cilindro = {
		field: "cilindro",
		headerName: "Cilindro",
		headerAlign: "center",
		align: "center",
		flex: 1,
		type: "number",
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.cilindro;
			_val = _val ? _val.toFixed(2) : "";
			return _val;
		},
	};

	const indicacion = {
		field: "descripcion_sl_indicacion",
		headerName: "Indicación",
		headerAlign: "center",
		align: "left",
		flex: 2,
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.descripcion_sl_indicacion;
			_val = _val ? _val.toUpperCase() : "";
			return _val;
		},
	};

	const precioVentaLista = {
		field: "precio_venta_lista",
		headerName: "Prc Venta",
		headerAlign: "center",
		align: "right",
		flex: 1,
		type: "number",
		sortable: false,
		renderCell: (params) => {
			let _val = params.row.precio_venta_lista.toFixed(2);
			_val = _val ? _val : "";
			return _val;
		},
	};

	const acciones = {
		field: "actions",
		headerName: "Acciones",
		headerAlign: "center",
		align: "left",
		flex: 1,
		sortable: false,
		filterable: false,
		renderCell: (params) => (
			<>
				{params.row.cu !== "view" && (
					<Tooltip title="seleccionar">
						<IconButton
							size="small"
							aria-label="update"
							onClick={() => handleRowClick(params.row)}
						>
							<CheckIcon />
						</IconButton>
					</Tooltip>
				)}
			</>
		),
	};

	const columnsArAs = [
		codigo,
		descripcion,
		marcaArAS,
		modelo,
		precioVentaLista,
		acciones,
	];

	const columnsLC = [
		codigo,
		descripcion,
		marcaLC,
		tiempoUso,
		esfera,
		cilindro,
		precioVentaLista,
		acciones,
	];

	const columnsSL = [
		codigo,
		descripcion,
		marcaSL,
		indicacion,
		precioVentaLista,
		acciones,
	];

	const columnsAC = [
		codigo,
		descripcion,
		precioVentaLista,
		acciones
	];

	const handlePaginationModelChange = (newModel) => {
		setCurrentPage(newModel.page);
		setRowsPerPage(newModel.pageSize);
	};

	const tableOptions = {
		paginationMode: "server",
		rowCount: totalRowsCount,
		paginationModel: {
			page: currentPage,
			pageSize: rowsPerPage,
		},
		onPaginationModelChange: handlePaginationModelChange,
		pageSizeOptions: [10, 20, 30],
		disableRowSelectionOnClick: true,
		disableColumnMenu: true,
		disableColumnFilter: true,
		disableColumnSelector: true,
		disableDensitySelector: true,
		localeText: {
			noRowsLabel: "",
			noResultsOverlayLabel: "",
			MuiTablePagination: {
				labelRowsPerPage: "Filas:",
				labelDisplayedRows: ({ from, to, count }) =>
					`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
			},
		},
		sx: {
			"& .MuiDataGrid-cell": {
				fontSize: "0.9em",
			},
			"& .MuiDataGrid-columnHeaders": {
				backgroundColor: "#f5f5f5",
			},
		},
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		loadArAsMarcas();
		loadArAsCategorias();
		loadArAsMateriales();
		loadArAsFormatos();
		loadArAsCalibres();
		loadArAsTipos();
		loadLcMarcas();
		loadLcTiemposUso();
		loadSlMarcas();
		loadSlIndicaciones();
	}, []);
	//
	// ################################################################################
	//
	const loadArAsMarcas = async () => {
		const response = await getCacheData("ar_as_marca")
		if (response.ok) {
			setArAsMarcas(response.data.data);
		} else {
			setArAsMarcas([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsCategorias = async () => {
		const response = await getCacheData("ar_as_categoria")
		if (response.ok) {
			setArAsCategorias(response.data.data);
		} else {
			setArAsCategorias([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsMateriales = async () => {
		const response = await getCacheData("ar_as_material")
		if (response.ok) {
			setArAsMateriales(response.data.data);
		} else {
			setArAsMateriales([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsFormatos = async () => {
		const response = await getCacheData("ar_as_formato")
		if (response.ok) {
			setArAsFormatos(response.data.data);
		} else {
			setArAsFormatos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsCalibres = async () => {
		const response = await getCacheData("ar_as_calibre")
		if (response.ok) {
			setArAsCalibres(response.data.data);
		} else {
			setArAsCalibres([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsTipos = async () => {
		const response = await getCacheData("ar_as_tipo")
		if (response.ok) {
			setArAsTipos(response.data.data);
		} else {
			setArAsTipos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadLcMarcas = async () => {
		const response = await getCacheData("lc_marca")
		if (response.ok) {
			setLcMarcas(response.data.data);
		} else {
			setLcMarcas([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadLcTiemposUso = async () => {
		const response = await getCacheData("lc_tiempo_uso")
		if (response.ok) {
			setLcTiemposUso(response.data.data);
		} else {
			setLcTiemposUso([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadSlMarcas = async () => {
		const response = await getCacheData("sl_marca")
		if (response.ok) {
			setSlMarcas(response.data.data);
		} else {
			setSlMarcas([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadSlIndicaciones = async () => {
		const response = await getCacheData("sl_indicacion")
		if (response.ok) {
			setSlIndicaciones(response.data.data);
		} else {
			setSlIndicaciones([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		switch (searchData.tipoArticulo) {
			case "AR":
				setTableColumns(columnsArAs);
				break;
			case "AS":
				setTableColumns(columnsArAs);
				break;
			case "LC":
				setTableColumns(columnsLC);
				break;
			case "AC":
				setTableColumns(columnsAC);
				break;
			case "SL":
				setTableColumns(columnsSL);
				break;
			default:
		}

		load();
	}, [currentPage, rowsPerPage, searchData.tipoArticulo]);
	//
	// ################################################################################
	//
	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]: e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleLimpiar = () => {
		setSearchData(initialSearchData);
	};
	//
	// ################################################################################
	//
	const handleBuscar = () => {
		load();
	};
	//
	// ################################################################################
	//
	const load = async () => {

		let _params = {
			tipoArticulo: searchData.tipoArticulo,
			codigo: searchData.codigo,
			descripcion: searchData.descripcion,
			arAsMarca: searchData.arAsMarca,
			arAsModelo: searchData.arAsModelo,
			arAsCategoria: searchData.arAsCategoria,
			arAsMaterial: searchData.arAsMaterial,
			arAsFormato: searchData.arAsFormato,
			arAsCalibre: searchData.arAsCalibre,
			arAsTipo: searchData.arAsTipo,
			slMarca: searchData.slMarca,
			slIndicacion: searchData.slIndicacion,
			lcMarca: searchData.lcMarca,
			lcTiempoUso: searchData.lcTiempoUso,
			lcEsfera: searchData.lcEsfera,
			lcCilindro: searchData.lcCilindro,
			precioVentaDesde: searchData.precioVentaDesde,
			precioVentaHasta: searchData.precioVentaHasta,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
			area: localStorage.getItem("id_area_ventas"),
		};

		let response = {};
		setIsDoingSomething(true);
		switch (searchData.tipoArticulo) {
			case "AR":
			case "AS":
				response = await getArmazonesAnteojosSol(_params);
				break;
			case "LC":
				response = await getLentesDeContacto(_params);
				break;
			case "AC":
				response = await getAccesorios(_params);
				break;
			case "SL":
				response = await getSolucionesLimpieza(_params);
				break;
			default:
		}
		setIsDoingSomething(false);

		if (response.ok) {
			setTotalRowsCount(response.data.count);
			setArticulos((articulos) => response.data.data);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const handleRowClick = (parRow) => {
		onSelect(parRow);
	};
	//
	// ################################################################################
	//
	const handleCloseDialog = () => {
		onClose();
	};
	//
	// ################################################################################
	//
	return (
		<>
			<Dialog
				open={open}
				onClose={handleCloseDialog}
				maxWidth="xl"
				fullWidth={true}
				scroll="paper"
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Búsqueda de Productos
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers>
					<Box>
						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12}>
								{/* Tipo de articulo Armazon, Anteojo de Sol, Todos */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="tipo-articulo-select-label">
										Tipo de Artículo
									</InputLabel>
									<Select
										labelId="tipo-articulo-select-label"
										id="tipo-articulo-select"
										name="tipoArticulo"
										value={searchData.tipoArticulo}
										label="Tipo de Artículo"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{tipoArticulo.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* Codigo de articulo */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="codigo"
									label="Código"
									value={searchData.codigo}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Descripcion */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="descripcion"
									label="Descripción"
									value={searchData.descripcion}
									onChange={handleChange}
								/>
							</Grid>
							{(searchData.tipoArticulo === "AR" ||
								searchData.tipoArticulo === "AS") && (
									// Si el tipo seleccionado por el usuario es AR o AS
									<>
										<Grid item xs={12} md={4}>
											{/* Marca */}

											<FormControl fullWidth sx={{ width: "100%" }}>
												<InputLabel id="marca-select-label">Marca</InputLabel>
												<Select
													labelId="marca-select-label"
													id="marca-select"
													name="arAsMarca"
													value={searchData.arAsMarca}
													label="Marca"
													size="small"
													onChange={handleChange}
													MenuProps={{ style: { maxHeight: "300px" } }}
												>
													{arAsMarcas.map((item) => (
														<MenuItem key={item.id} value={item.id}>
															{item.descripcion}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>

										<Grid item xs={12} md={4}>
											{/* Modelo */}

											<TextField
												sx={{ width: "100%" }}
												variant="outlined"
												size="small"
												name="arAsModelo"
												label="Modelo"
												value={searchData.arAsModelo}
												onChange={handleChange}
											/>
										</Grid>
										<Grid item xs={12} md={4}>
											{/* Categoria */}

											<FormControl fullWidth sx={{ width: "100%" }}>
												<InputLabel id="categoria-select-label">
													Categoría
												</InputLabel>
												<Select
													labelId="categoria-select-label"
													id="categoria-select"
													name="arAsCategoria"
													value={searchData.arAsCategoria}
													label="Categoría"
													size="small"
													onChange={handleChange}
													MenuProps={{ style: { maxHeight: "300px" } }}
												>
													{arAsCategorias.map((item) => (
														<MenuItem key={item.id} value={item.id}>
															{item.descripcion}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} md={4}>
											{/* Material */}

											<FormControl fullWidth sx={{ width: "100%" }}>
												<InputLabel id="material-select-label">
													Material
												</InputLabel>
												<Select
													labelId="material-select-label"
													id="material-select"
													name="arAsMaterial"
													value={searchData.arAsMaterial}
													label="Material"
													size="small"
													onChange={handleChange}
													MenuProps={{ style: { maxHeight: "300px" } }}
												>
													{arAsMateriales.map((item) => (
														<MenuItem key={item.id} value={item.id}>
															{item.descripcion}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} md={4}>
											{/* Formato */}

											<FormControl fullWidth sx={{ width: "100%" }}>
												<InputLabel id="formato-select-label">Formato</InputLabel>
												<Select
													labelId="formato-select-label"
													id="formato-select"
													name="arAsFormato"
													value={searchData.arAsFormato}
													label="Formato"
													size="small"
													onChange={handleChange}
													MenuProps={{ style: { maxHeight: "300px" } }}
												>
													{arAsFormatos.map((item) => (
														<MenuItem key={item.id} value={item.id}>
															{item.descripcion}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>

										<Grid item xs={12} md={4}>
											{/* Calibre */}

											<FormControl fullWidth sx={{ width: "100%" }}>
												<InputLabel id="calibre-select-label">Calibre</InputLabel>
												<Select
													labelId="calibre-select-label"
													id="calibre-select"
													name="arAsCalibre"
													value={searchData.arAsCalibre}
													label="Calibre"
													size="small"
													onChange={handleChange}
													MenuProps={{ style: { maxHeight: "300px" } }}
												>
													{arAsCalibres.map((item) => (
														<MenuItem key={item.id} value={item.id}>
															{item.valor}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>

										<Grid item xs={12} md={4}>
											<FormControl fullWidth sx={{ width: "100%" }}>
												<InputLabel id="tipo-select-label">Tipo</InputLabel>
												<Select
													labelId="tipo-select-label"
													id="tipo-select"
													name="arAsTipo"
													value={searchData.arAsTipo}
													label="Tipo"
													size="small"
													onChange={handleChange}
													MenuProps={{ style: { maxHeight: "300px" } }}
												>
													{arAsTipos.map((item) => (
														<MenuItem key={item.id} value={item.id}>
															{item.descripcion}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Grid>
									</>
								)}

							{searchData.tipoArticulo === "LC" && (
								// Si el tipo seleccionado por el usuario es LC
								<>
									<Grid item xs={12} md={4}>
										{/* Marca */}

										<FormControl fullWidth sx={{ width: "100%" }}>
											<InputLabel id="marca-select-label">Marca</InputLabel>
											<Select
												labelId="marca-select-label"
												id="marca-select"
												name="lcMarca"
												value={searchData.lcMarca}
												label="Marca"
												size="small"
												onChange={handleChange}
												MenuProps={{ style: { maxHeight: "300px" } }}
											>
												{lcMarcas.map((item) => (
													<MenuItem key={item.id} value={item.id}>
														{item.descripcion}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>

									<Grid item xs={12} md={4}>
										{/* Tiempo de uso */}

										<FormControl fullWidth sx={{ width: "100%" }}>
											<InputLabel id="tiempo-uso-select-label">
												Tiempo de uso
											</InputLabel>
											<Select
												labelId="tiempo-uso-select-label"
												id="tiempo-uso-select"
												name="lcTiempoUso"
												value={searchData.lcTiempoUso}
												label="Tiempo de uso"
												size="small"
												onChange={handleChange}
												MenuProps={{ style: { maxHeight: "300px" } }}
											>
												{lcTiemposUso.map((item) => (
													<MenuItem key={item.id} value={item.id}>
														{item.descripcion}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>

									<Grid item xs={12} md={4}>
										{/* Esfera */}

										<TextField
											sx={{ width: "100%" }}
											id="esfera"
											size="small"
											name="lcEsfera"
											label="Esfera"
											value={searchData.lcEsfera}
											onChange={handleChange}
										/>
									</Grid>
									<Grid item xs={12} md={4}>
										{/* Cilindro */}

										<TextField
											sx={{ width: "100%" }}
											id="cilindro"
											size="small"
											name="lcCilindro"
											label="Cilindro"
											value={searchData.lcCilindro}
											onChange={handleChange}
										/>
									</Grid>
								</>
							)}

							{searchData.tipoArticulo === "SL" && (
								// Si el tipo seleccionado por el usuario es SL
								<>
									<Grid item xs={12} md={4}>
										{/* Marca */}

										<FormControl fullWidth sx={{ width: "100%" }}>
											<InputLabel id="marca-select-label">Marca</InputLabel>
											<Select
												labelId="marca-select-label"
												id="marca-select"
												name="slMarca"
												value={searchData.slMarca}
												label="Marca"
												size="small"
												onChange={handleChange}
												MenuProps={{ style: { maxHeight: "300px" } }}
											>
												{slMarcas.map((item) => (
													<MenuItem key={item.id} value={item.id}>
														{item.descripcion}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>

									<Grid item xs={12} md={4}>
										{/* Tiempo de uso */}

										<FormControl fullWidth sx={{ width: "100%" }}>
											<InputLabel id="tiempo-uso-select-label">
												Indicación
											</InputLabel>
											<Select
												labelId="indicacion-select-label"
												id="indicacion-select"
												name="slIndicacion"
												value={searchData.slIndicacion}
												label="Indicación"
												size="small"
												onChange={handleChange}
												MenuProps={{ style: { maxHeight: "300px" } }}
											>
												{slIndicaciones.map((item) => (
													<MenuItem key={item.id} value={item.id}>
														{item.descripcion}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>
								</>
							)}
							<Grid item xs={12} md={4}>
								{/* Precio de Venta Desde */}

								<TextField
									sx={{ width: "100%" }}
									id="precio-venta-desde"
									size="small"
									name="precioVentaDesde"
									label="Desde precio"
									value={searchData.precioVentaDesde}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Precio de Venta Hasta */}

								<TextField
									sx={{ width: "100%" }}
									id="precio-venta-hasta"
									size="small"
									name="precioVentaHasta"
									label="Hasta precio"
									value={searchData.precioVentaHasta}
									onChange={handleChange}
								/>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ mb: 1, float: "right" }}>
						<Button
							sx={{ mr: 1 }}
							variant="contained"
							onClick={handleBuscar}
							startIcon={<SearchIcon />}
						>
							Buscar
						</Button>
						<Button
							sx={{ mr: 1 }}
							variant="outlined"
							onClick={handleLimpiar}
							startIcon={<CleaningServicesIcon />}
						>
							Limpiar
						</Button>
					</Box>

					<Paper
						sx={{
							width: "100%",
							overflow: "hidden",
							border: "1px solid LightGrey",
						}}
					>
						<DataGrid
							rows={articulos}
							columns={tableColumns}
							{...tableOptions}
						/>
					</Paper>
				</DialogContent>
			</Dialog>

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}

			<WaitingDialog open={isDoingSomething} />
		</>
	);
};
export default BuscarProductoDialog;
